module.exports = __webpack_public_path__ + "569ed4652ff395bfd97eb87baea10d25.svg";